module.exports = __webpack_public_path__ + "static/media/LogoMobile.7f6b685f.svg";